/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import PropTypes from "prop-types";

import styles from "./Login.module.css";

const APP_VERSION = process.env.REACT_APP_ADMIN_VERSION;

const Login = ({ signIn }) => {
	return (
		<div className={styles.container}>
			<div className={`${styles.content} card`}>
				<img src="/images/pace_main_logo.png" style={{ width: 250 }} alt="PACE" />
				<div className={styles.buttonDiv}>
					<button
						className={`${styles.button} btn btn-primary`}
						type="button"
						onClick={signIn}
						variant="contained"
						color="secondary"
					>
						Sign In
					</button>

					{APP_VERSION && (
						<div
							style={{
								color: "#000",
								fontSize: 12,
								fontWeight: 600,
								textAlign: "center",
								marginTop: 20,
							}}
						>
							{APP_VERSION}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

Login.propTypes = {
	signIn: PropTypes.func.isRequired,
};

export default Login;
